var ur = window.location.href;
if(ur.includes('/blog')){
jQuery(document).ready(function(){
  
jQuery('.article__content.rte p').eq(1).after(' <div class="pp-fs"> <div class="pp-fs-title">Stay updated and GET 5% OFF your first purchase.</div><div class="pp-fs-subtitle">Join our “Deep Dive” newsletter to get swimming pool tips and updates on new products, events, and promos.</div><div class="pp-fs-form"> </div><div class="pp-fs-fomo">No spam. Unsubscribe anytime!</div></div>')
jQuery('.pp-fs-form').append(jQuery('form#newsletter-static-newsletter'))

jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('.pp-fs-fomo').eq(0).offset().top) {
       jQuery('.newsletter').prepend(jQuery('form#newsletter-static-newsletter'))

    } else {
  
   jQuery('.pp-fs-form').append(jQuery('form#newsletter-static-newsletter'))
        
    }
}); 
  
  
  
});
}




var ur = window.location.href;
if(ur.includes('/product')){
var ss = 0; var timerss = setInterval(function(){
  if(document.querySelectorAll('button.product-form__add-button').length) {

document.querySelectorAll('button.product-form__add-button')[0].addEventListener('click', function(){
document.querySelectorAll('body')[0].classList.add('conv-redirect');
  var count = document.querySelectorAll('span.header__cart-count')[0].innerHTML;
  var x = 0;
  console.log(count + "==" + document.querySelectorAll('span.header__cart-count')[0].innerHTML);
var cTimer = setInterval(function(){
  if(count != document.querySelectorAll('span.header__cart-count')[0].innerHTML || x > 200) {
	 window.location.href = '/cart';
     clearInterval(cTimer);
  }
x++;
}, 50);
}); 
      	
clearInterval(timerss);}if( ss > 200){clearInterval(timerss);}ss++;}, 50);
  
}



var ur = window.location.href;
if(ur.includes('/product')){

jQuery(document).ready(function(){
  
  
    if(window.innerWidth > 768){
      
      var bb = 0; var timerbb = setInterval(function(){
  if($('.cbb-frequently-bought-container.cbb-desktop-view').length) {
	      	  $('.product-block-list.product-block-list--small').eq(0).after($('section.section.section--tight[data-section-type="text-with-icons"]').eq(0));
clearInterval(timerbb);}if( bb > 200){clearInterval(timerbb);}bb++;}, 50);
      	  $('.product-block-list.product-block-list--small').eq(0).after($('section.section.section--tight[data-section-type="text-with-icons"]').eq(0));
    }
    else{
      	  $('.product-block-list__item.product-block-list__item--info').eq(0).after($('section.section.section--tight[data-section-type="text-with-icons"]').eq(0));
    }
    window.onresize=function(){
       if(window.innerWidth > 768){
      	  $('.product-block-list.product-block-list--small').eq(0).after($('section.section.section--tight[data-section-type="text-with-icons"]').eq(0));
    }
    else{
      	  $('.product-block-list__item.product-block-list__item--info').eq(0).after($('section.section.section--tight[data-section-type="text-with-icons"]').eq(0));
    }
    }
});
}
